/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Students_EmptyInputs */

const en_students_empty = /** @type {(inputs: Students_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No students yet.`)
};

const he_students_empty = /** @type {(inputs: Students_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין תלמידים עדיין.`)
};

/**
* | output |
* | --- |
* | "No students yet." |
*
* @param {Students_EmptyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const students_empty = /** @type {((inputs?: Students_EmptyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Students_EmptyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_students_empty(inputs)
	return he_students_empty(inputs)
});